
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { mapData } from "@/utilities/DataMapping";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import VisitorCompanyDialogue from "@/vue/components/VisitorCompanyDialogue.vue";
    import { VisitorCompanySearchParameters } from "@/model/VisitorCompanySearchParameters";
    import { IVisitorCompany, VisitorCompany } from "@/model/VisitorCompany";

    @Component({
        components: { ApiButton, VisitorCompanyDialogue }
    })
    export default class VisitorCompanies extends Vue {

        async mounted(): Promise<void> {
            await this.loadVisitorCompanies();
        }

        @Prop({ required: true })
        siteID!: string;

        get isNewSite(): boolean { return Utils.isEmptyId(this.siteID); }
        visitorCompanyHeaders = [
            { text: "Name", value: "name", sortable: false }
        ];
        infiniteId: number = + new Date();
        searchParameters = new VisitorCompanySearchParameters();
        visitorCompanyList: Array<IVisitorCompany> = [];

        //
        // -- Watchers
        //

        debouncedRefreshSearch = Utils.debounce(this.loadVisitorCompanies, 200);

        @Watch("searchParameters.searchText")
        onSearchTextchanged(): void {
            this.debouncedRefreshSearch();
        }

        @Watch("siteID")
        onSiteIDchanged(): void {
            this.loadVisitorCompanies();
        }

        onSaved(): void {
            this.$emit("changed");
            this.loadVisitorCompanies();
        }

        //
        // -- methods
        //

        editNew(): void {
            const dialog: VisitorCompanyDialogue = this.$refs.visitorCompanyDialogue as VisitorCompanyDialogue;
            dialog.add(this.siteID);
        }

        edit(visitorCompany: IVisitorCompany): void {
            const dialog: VisitorCompanyDialogue = this.$refs.visitorCompanyDialogue as VisitorCompanyDialogue;
            dialog.edit(visitorCompany.id);
        }

        async loadVisitorCompanies(): Promise<void> {
            if(this.isNewSite) {
                 this.visitorCompanyList = [];
                 return;
            }
            this.searchParameters.siteID = this.siteID;
            const data = await ApiClient.post("/Api/VisitorCompany/Search", this.searchParameters);
            this.visitorCompanyList = mapData<Array<VisitorCompany>>(data, { root: (s) => new VisitorCompany (s) });
        }

    }
